"use strict";
// Copyright 2019 Centrality Investments Limited
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Object.defineProperty(exports, "__esModule", { value: true });
const operators_1 = require("rxjs/operators");
const utils_1 = require("../utils/utils");
function totalLiquidity(api) {
    return (assetId) => {
        return api.query.cennzxSpot.coreAssetId().pipe(operators_1.switchMap(coreAssetId => {
            const exchangeKey = utils_1.getExchangeKey(coreAssetId, assetId);
            return api.query.cennzxSpot.totalSupply(exchangeKey);
        }));
    };
}
exports.totalLiquidity = totalLiquidity;
function totalLiquidityAt(api) {
    return (hash, assetId) => {
        return api.query.cennzxSpot.coreAssetId.at(hash).pipe(operators_1.switchMap(coreAssetId => {
            const exchangeKey = utils_1.getExchangeKey(coreAssetId, assetId);
            return api.query.cennzxSpot.totalSupply.at(hash, exchangeKey);
        }));
    };
}
exports.totalLiquidityAt = totalLiquidityAt;
//# sourceMappingURL=totalLiquidity.js.map